import AuthService from 'services/authService';

export const getExpertId = () => {
  const user = AuthService.current();

  if (!user) {
    return null;
  }

  const simplrExpert = user.simplrExpert;

  if (!simplrExpert) {
    return null;
  }

  return simplrExpert.id;
};

export const getUserId = () => {
  const user = AuthService.current();

  if (!user) {
    return null;
  }

  return user.id;
};

export const getSessionToken = () => {
  const user = AuthService.current();

  return user?.sessionToken || null;
};
